import { SURVEY_BASE_URL } from './constants';

/**
 * Constructs the external URL used to call the remote survey service api.
 *
 * @param instanceId The instance identifier token.
 * @returns Fully constructed target URL.
 */
export function buildExternalSurveyUrl(instanceId: string): string {
  return `${SURVEY_BASE_URL}?instanceId=${encodeURIComponent(instanceId)}&draftPreview=false`;
}

/**
 * High-level function that constructs the survey fetch URL.
 * Returns empty string when instanceId is missing — fetch must not run until INPUT 2 JWT is set.
 *
 * @returns Target URL for fetch requests, or '' when no instanceId.
 */
export function buildSurveyUrl(instanceId?: string): string {
  const targetId =
    typeof instanceId === 'string' && instanceId.trim().length > 0 ? instanceId.trim() : '';
  if (!targetId) return '';
  return buildExternalSurveyUrl(targetId);
}
